(() => {
  if (window.agwVerifiedManualLabelsReady) return;
  window.agwVerifiedManualLabelsReady = true;
  const oldLabel = 'Manual Safety Pilot (Manual Flame Control)';
  const displayLabel = 'Manual Safety Pilot (Variable Flame On/Off Knob)';
  const update = () => document.querySelectorAll('[data-agw-verified-manual-label]').forEach((node) => {
    if (node.textContent.trim() === oldLabel) node.textContent = displayLabel;
  });
  const start = () => {
    // Stiletto can replace product markup after initialization or variant updates.
    // Observe replacements as well as text, but update only explicitly scoped labels.
    new MutationObserver(update).observe(document.body, { childList: true, subtree: true, characterData: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
